(function () {
  // Guard against double-init (AJAX navigations may re-inject the script)
  if (window.__twcCalculatorInit) return;
  window.__twcCalculatorInit = true;

  function initCalculator() {
    // ------------------------------------------------------------
    // 1) HOIST the drawer + backdrop to <body> to escape stacking contexts
    // ------------------------------------------------------------
    function hoistCalculatorOverlayToBody() {
      const drawers = document.querySelectorAll("#twc-drawer");
      const backdrops = document.querySelectorAll("#twc-backdrop");
      drawers.forEach((el, i) => { if (i > 0) el.remove(); });
      backdrops.forEach((el, i) => { if (i > 0) el.remove(); });

      const drawerEl = document.getElementById("twc-drawer");
      const backdropEl = document.getElementById("twc-backdrop");

      if (backdropEl && backdropEl.parentElement !== document.body) document.body.appendChild(backdropEl);
      if (drawerEl && drawerEl.parentElement !== document.body) document.body.appendChild(drawerEl);
    }

    hoistCalculatorOverlayToBody();

    // ------------------------------------------------------------
    // 2) Nodes
    // ------------------------------------------------------------
    const openBtns       = document.querySelectorAll('[data-calculator-trigger]');
    const openBtn        = openBtns[0];
    const closeBtn       = document.getElementById('twc-close-btn');
    const backdrop       = document.getElementById('twc-backdrop');
    const drawer         = document.getElementById('twc-drawer');
    const addWallBtn     = document.getElementById('add-wall-btn');
    const wallsContainer = document.getElementById('walls-container');
    const rollsDisplay   = document.querySelector('.twc-rolls');
    const applyBtn       = document.querySelector('#twc-apply-qty, [data-twc-apply-qty]');
    const calcRoot       = document.getElementById('wallpaper-calculator');

    if (!openBtn || !drawer || !backdrop || !calcRoot) return;

    // baseline closed state — but DON'T slam shut a drawer the user already has open.
    // A deferred shopify:section:load (apps / lazy sections) re-runs init mid-session;
    // forcing display:none here is the "opens then disappears on first try" bug.
    if (!document.body.classList.contains('drawer-open')) {
      drawer.style.display = 'none';
      drawer.classList.remove('slide-in');
      drawer.classList.add('slide-out');
      backdrop.classList.remove('active');
    }

    // ------------------------------------------------------------
    // 3) Variant dims helpers (from data-variant-dims)
    // ------------------------------------------------------------
    function safeParseVariantMap() {
      const raw = calcRoot.dataset.variantDims;
      if (!raw) return null;
      try { return JSON.parse(raw); } catch { return null; }
    }

    function setDimsForVariantId(variantId) {
      const map = safeParseVariantMap();
      if (!map) return false;

      const dims = map[String(variantId)];
      if (!dims) return false;

      // store inches in dataset (numbers)
      calcRoot.dataset.rollWidthIn  = String(dims.w);
      calcRoot.dataset.rollLengthIn = String(dims.l);
      return true;
    }

    function getRollDimsInches() {
      const w = parseFloat(calcRoot.dataset.rollWidthIn || '36') || 36;
      const l = parseFloat(calcRoot.dataset.rollLengthIn || '108') || 108;
      return { w, l };
    }

    function updateSheetSizeLine() {
      const el = document.querySelector('[data-sheet-size]');
      if (!el) return;

      const { w, l } = getRollDimsInches();
      const wCm = Math.round(w * 2.54 * 100) / 100;
      const lCm = Math.round(l * 2.54 * 100) / 100;

      el.textContent = `${w}" × ${l}" (${wCm} cm × ${lCm} cm) rolls`;
    }

    // Find the current variant id input (Pipeline/Dawn style)
    function findVariantIdInput() {
      return (
        document.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('product-form form [name="id"]') ||
        document.querySelector('[name="id"][type="hidden"]')
      );
    }

    function refreshCalculatorForCurrentVariant() {
      const idInput = findVariantIdInput();
      const id = idInput ? Number(idInput.value) : null;
      if (id) setDimsForVariantId(id);
      updateSheetSizeLine();
      calculateTotalRolls();
    }

    // ------------------------------------------------------------
    // 4) Drawer open/close
    // ------------------------------------------------------------
    // A close cycle owns exactly one fallback timer + one transitionend handler.
    // Tracking them at init scope lets openDrawer abort an in-flight (or stale)
    // close so it can never slam a freshly-opened drawer shut.
    let closeFallbackTimer = null;
    let closeTransitionHandler = null;

    function cancelPendingClose() {
      if (closeFallbackTimer) { clearTimeout(closeFallbackTimer); closeFallbackTimer = null; }
      if (closeTransitionHandler) {
        drawer.removeEventListener('transitionend', closeTransitionHandler);
        closeTransitionHandler = null;
      }
    }

    function openDrawer() {
      // re-hoist in case Shopify section rendering replaced the elements
      hoistCalculatorOverlayToBody();

      // A previous close may still have a pending transitionend/fallback that
      // would force display:none on the drawer we're about to show. Kill it.
      cancelPendingClose();

      // keep calculator synced each time it opens
      refreshCalculatorForCurrentVariant();

      // ensure the toggle group is visible
      const toggleGroup = drawer.querySelector('#twc-unit-toggle');
      if (toggleGroup) toggleGroup.style.display = '';
      const toggleRow = drawer.querySelector('.twc-unit-toggle-row');
      if (toggleRow) toggleRow.style.display = '';

      drawer.style.display = 'block';
      drawer.classList.remove('slide-in');
      drawer.classList.add('slide-out');
      void drawer.offsetWidth;

      requestAnimationFrame(() => {
        drawer.classList.remove('slide-out');
        drawer.classList.add('slide-in');
        backdrop.classList.add('active');
        document.body.classList.add('drawer-open');
      });
    }

    function closeDrawer() {
      // never let two close cycles stack their timers/listeners
      cancelPendingClose();

      drawer.classList.remove('slide-in');
      drawer.classList.add('slide-out');

      let finished = false;
      function done() {
        if (finished) return;          // idempotent: timer + transitionend can't both fire it
        finished = true;
        cancelPendingClose();          // always detach our own handler/timer
        backdrop.classList.remove('active');
        document.body.classList.remove('drawer-open');
        drawer.style.display = 'none';
        openBtn?.focus?.();
      }

      closeTransitionHandler = function (e) {
        if (e.target !== drawer || e.propertyName !== 'transform') return;
        done();
      };
      drawer.addEventListener('transitionend', closeTransitionHandler);
      closeFallbackTimer = setTimeout(done, 400);
    }

    // ------------------------------------------------------------
    // 5) Quantity helpers
    // ------------------------------------------------------------
    function findQuantityInput() {
      const candidates = [
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]'),
        document.querySelector('product-form form input[name="quantity"]'),
        document.querySelector('quantity-input input[name="quantity"]'),
        document.querySelector('.quantity__input[name="quantity"]'),
        document.querySelector('input[name="quantity"].js-qty__num'),
        document.querySelector('input[type="number"][name="quantity"]')
      ];
      return candidates.find(el => el && el.offsetParent !== null) || null;
    }

    function setProductQuantity(qty) {
      const input = findQuantityInput();
      if (!input) return false;
      input.value = String(qty);
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function setApplyEnabled(enabled) {
      if (!applyBtn) return;
      applyBtn.disabled = !enabled;
      applyBtn.setAttribute('aria-disabled', String(!enabled));
    }

    // ------------------------------------------------------------
    // 6) Calculator math (USES CURRENT VARIANT DIMS)
    // ------------------------------------------------------------
    function getUnitValue() {
      const checked = drawer.querySelector('input[name="unit"]:checked');
      return checked ? checked.value : 'inches';
    }

    function calculateTotalRolls() {
      if (!rollsDisplay) return;

      const unit  = getUnitValue(); // 'centimeters' | 'inches'
      const walls = document.querySelectorAll('.wall-row');
      let total = 0;

      const { w: rollWIn, l: rollLIn } = getRollDimsInches();
      const rollWCm = rollWIn * 2.54;
      const rollLCm = rollLIn * 2.54;

      walls.forEach(row => {
        let width  = parseFloat(row.querySelector('.wall-width')?.value)  || 0;
        let height = parseFloat(row.querySelector('.wall-height')?.value) || 0;
        if (width === 0 || height === 0) return;

        let stripsNeeded, verticalRepeats;

        if (unit === 'centimeters') {
          stripsNeeded    = Math.ceil(width  / rollWCm);
          verticalRepeats = Math.ceil(height / rollLCm);
        } else {
          stripsNeeded    = Math.ceil(width  / rollWIn);
          verticalRepeats = Math.ceil(height / rollLIn);
        }

        total += stripsNeeded * verticalRepeats;
      });

      rollsDisplay.textContent = total;
      setApplyEnabled(total > 0);
      if (total === 0) setProductQuantity(1);
    }

    // ------------------------------------------------------------
    // 7) Wall rows
    // ------------------------------------------------------------
    function updateWallNumbers() {
      document.querySelectorAll('.wall-row').forEach((row, i) => {
        const label = row.querySelector('.wall-meta span');
        if (label) label.textContent = `Wall ${i + 1}`;
      });
    }

    function addWallRow() {
      if (!wallsContainer) return;

      const unit      = getUnitValue();
      const unitLabel = unit === 'centimeters' ? 'cm' : 'in';

      const row = document.createElement('div');
      row.className = 'wall-row';
      row.innerHTML = `
        <div class="wall-meta">
          <img src="https://cdn.shopify.com/s/files/1/0607/2546/1110/files/Wall_Icon_283f2a68-86fd-490d-8a7f-12cfdf3eff50.svg?v=1754364485" alt="Wall icon" />
          <span></span>
        </div>
        <div class="wall-input-group">
          <label>Width</label>
          <div class="wall-input-container" data-unit="${unitLabel}">
            <input type="number" class="wall-width" min="0" step="any">
          </div>
        </div>
        <div class="wall-input-group">
          <label>Height</label>
          <div class="wall-input-container" data-unit="${unitLabel}">
            <input type="number" class="wall-height" min="0" step="any">
          </div>
        </div>
        <button class="remove-wall" title="Remove wall">&times;</button>
      `;

      row.querySelectorAll('input').forEach(i => i.addEventListener('input', calculateTotalRolls));
      row.querySelector('.remove-wall')?.addEventListener('click', () => {
        row.remove();
        updateWallNumbers();
        calculateTotalRolls();
      });

      wallsContainer.appendChild(row);
      updateWallNumbers();
      calculateTotalRolls();
    }

    // ------------------------------------------------------------
    // 8) Bindings
    // ------------------------------------------------------------
    if (applyBtn) {
      if (!applyBtn.getAttribute('type')) applyBtn.setAttribute('type', 'button');
      applyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const total = Number(String(rollsDisplay?.textContent || '').replace(/[^\d]/g, '')) || 0;
        setProductQuantity(total > 0 ? total : 1);
        closeDrawer();
      });
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });

    // Buy-box CALCULATOR button + quantity stepper are now matched to ONE fixed
    // height in CSS (tool-wallpaper-calculator-multi.liquid) — deterministic across
    // breakpoints. The old JS offsetHeight sync was removed (it raced font-load +
    // sub-pixel rounding, so desktop↔mobile could drift by a px or two).

    closeBtn?.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    addWallBtn?.addEventListener('click', addWallRow);

    drawer.addEventListener('change', (e) => {
      const radio = e.target.closest('input[name="unit"]');
      if (!radio) return;

      const unitLabel = radio.value === 'centimeters' ? 'cm' : 'in';
      drawer.querySelectorAll('.wall-input-container').forEach(c => {
        c.setAttribute('data-unit', unitLabel);
      });

      calculateTotalRolls();
    });

    // Watch variant changes (robust across themes)
    let lastVariantId = null;

    function syncIfVariantChanged() {
      const idInput = findVariantIdInput();
      const current = idInput ? String(idInput.value || '') : '';
      if (!current || current === lastVariantId) return;
      lastVariantId = current;
      refreshCalculatorForCurrentVariant();
    }

    // Single listener on current hidden id input
    const variantIdInput = findVariantIdInput();
    variantIdInput?.addEventListener('change', syncIfVariantChanged);

    // Additional listeners
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(syncIfVariantChanged, 0);
      }
    });

    // Fallback polling — clear any prior interval first. initCalculator re-runs on
    // shopify:section:load / :select, page:loaded, turbo:load, turbolinks:load, so without
    // this every SPA nav or section reload would stack ANOTHER 300ms poller (leak). One only.
    if (window.__twcVariantPollTimer) clearInterval(window.__twcVariantPollTimer);
    window.__twcVariantPollTimer = setInterval(syncIfVariantChanged, 300);

    // Init
    addWallRow();
    refreshCalculatorForCurrentVariant();
  }

  // ------------------------------------------------------------
  // ROBUST INITIALIZATION — handles all Shopify loading scenarios
  // ------------------------------------------------------------

  // 1) Standard full page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    // DOM already ready (script loaded after DOMContentLoaded, e.g. AJAX nav)
    initCalculator();
  }

  // 2) Shopify section rendering events (theme editor + AJAX section updates)
  document.addEventListener('shopify:section:load', function () {
    window.__twcCalculatorInit = false;
    initCalculator();
  });

  // 3) Shopify theme editor preview
  document.addEventListener('shopify:section:select', function () {
    window.__twcCalculatorInit = false;
    initCalculator();
  });

  // 4) Handle SPA-style navigations (Pipeline, Turbo, etc.)
  //    These fire when the page content changes without a full reload
  document.addEventListener('page:loaded', function () {
    window.__twcCalculatorInit = false;
    initCalculator();
  });
  document.addEventListener('turbo:load', function () {
    window.__twcCalculatorInit = false;
    initCalculator();
  });
  document.addEventListener('turbolinks:load', function () {
    window.__twcCalculatorInit = false;
    initCalculator();
  });
})();
